import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle, Circle, X, Swatches, Plugs, PaintBrush, ArrowRight } from "@phosphor-icons/react";
import { api } from "@/lib/api";

export const SetupChecklist = () => {
  const [ob, setOb] = useState(null);

  useEffect(() => {
    api.get("/onboarding").then(({ data }) => setOb(data)).catch(() => {});
  }, []);

  if (!ob || ob.checklist_dismissed) return null;
  const steps = [
    { key: "brand", done: ob.brand_done, label: "Set up your Brand Kit", desc: "Logo, colors & voice for every AI creative", to: "/brand", icon: Swatches },
    { key: "meta", done: ob.meta_connected, label: "Connect Meta", desc: "Sync your live campaigns, ads & leads", to: "/connect", icon: Plugs },
    { key: "creative", done: ob.first_creative, label: "Run your first AI creative", desc: "Let Riya design your first ad", to: "/team", icon: PaintBrush },
  ];
  const remaining = steps.filter((s) => !s.done).length;
  if (remaining === 0) return null;

  const dismiss = () => {
    setOb({ ...ob, checklist_dismissed: true });
    api.post("/onboarding/dismiss-checklist").catch(() => {});
  };

  return (
    <div className="bg-white border border-[#FFD8C4] rounded-lg p-6 relative" data-testid="setup-checklist">
      <button onClick={dismiss} data-testid="setup-checklist-dismiss" title="Dismiss"
        className="absolute top-4 right-4 text-[#8a90a0] hover:text-[#0A0D14] transition-colors p-1 rounded-md hover:bg-[#F3F4F6]">
        <X size={15} />
      </button>
      <div className="flex items-center gap-2">
        <h3 className="font-heading text-base font-extrabold tracking-tight text-[#0A0D14]">Finish setting up</h3>
        <span className="text-[10px] font-bold uppercase tracking-[0.15em] rounded-full bg-[#FF6B35]/10 text-[#E85A25] px-2.5 py-1">
          {steps.length - remaining}/{steps.length} done
        </span>
      </div>
      <div className="mt-4 grid sm:grid-cols-3 gap-3">
        {steps.map(({ key, done, label, desc, to, icon: Icon }) => (
          <Link key={key} to={to} data-testid={`setup-step-${key}`}
            className={`rounded-lg border px-4 py-3.5 flex items-start gap-3 transition-colors ${
              done ? "border-[#E5E7EB] bg-[#FAFAFB] opacity-70" : "border-[#FFD8C4] hover:border-[#FF6B35] bg-white"}`}>
            {done ? (
              <CheckCircle size={19} weight="fill" className="text-[#1a9e52] shrink-0 mt-0.5" />
            ) : (
              <Circle size={19} className="text-[#FF6B35] shrink-0 mt-0.5" />
            )}
            <span className="min-w-0">
              <span className={`block text-sm font-bold ${done ? "text-[#8a90a0] line-through" : "text-[#0A0D14]"}`}>{label}</span>
              <span className="block text-[11px] text-[#8a90a0] leading-snug mt-0.5">{desc}</span>
              {!done && (
                <span className="inline-flex items-center gap-1 text-[11px] font-bold text-[#FF6B35] mt-1.5">
                  <Icon size={12} weight="duotone" /> Go <ArrowRight size={11} weight="bold" />
                </span>
              )}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
};
